import Vue from 'vue';
import VueI18n from 'vue-i18n';
import i18nMessages from '@/i18n';
import * as BrowserUtils from './utils/browser';

Vue.use(VueI18n);

const BROWSER_LOCALE = BrowserUtils.getDefaultLanguage().toLowerCase();
export const i18n = new VueI18n({ // tslint:disable-line
    locale: BROWSER_LOCALE,
    messages: i18nMessages,
});
